export const USER_AUTH_STATE_KEY = 'user-auth-state';
export const PRESENTATION_MODE_KEY = 'presentation-mode';
